<template>
  <div class="admin-page admin-product-details">
    <div class="header">
      <button class="item" @click="clickPrevBtn"  style="float: left">
        뒤로
      </button>

      <div>
        <label>
          <input
            type="radio"
            v-model="product.hidden"
            name="isHidden"
            :value="false"
            :checked="!product.hidden"
            class="item"
          />공개
        </label>
        <label>
          <input
            class="item"
            type="radio"
            v-model="product.hidden"
            name="isHidden"
            :value="true"
          />비공개
        </label>
      </div>

      <div>
       
       
        <button
          @click="isPreview = !isPreview"
          class="item"
        >
          {{ isPreview ? "편집" : "미리보기" }}
        </button>

        <button

          v-if="pageType === 'edit'"
          @click="clickDelBtn"
          class="item"
          >
          삭제
          </button>

        <button @click="clickSaveBtn" class="vhp-button primary" >
          저장
        </button>
      </div>
    </div>

    <!-- 편집 모드 -->
    <div v-if="!isPreview" class="edit-container">
      <div class="row mb-16">
        <div class="col-30">
          <div class="image-container">
            <div class="image-preview">
              <div
                v-for="(image, index) in images"
                :key="index"
                class="image-preview-wrap"
                :class="{ active: index === activeImageIndex }"
                @click="activeImageIndex = index"
              >
                <img :src="image || ''" class="image-preview-card" />
                <button class="vhp-button round" @click="removeImage(index)">
                  <i class="fa-solid fa-times"></i>
                </button>
              </div>

              <div
                class="image-preview-wrap default"
                @click="$refs.imageInput.click()"
              >
                <i class="fa-solid fa-plus"></i>
              </div>
            </div>

            <div class="image-wrap">
              <img
                v-if="images.length > 0"
                class="image-card"
                :src="images[activeImageIndex]"
                :key="activeImageIndex || images.length"
              />
              <vhp-empty
                v-else
                :text="'이미지가 없습니다.'"
                :fullScreen="true"
                :showImage="true"
                class="image-card"
                @click="$refs.imageInput.click()"
              />

              <button
                class="vhp-button image-add-button"
                @click="$refs.imageInput.click()"
              >
                <div class="vhp-text small">이미지 추가</div>
              </button>
              <div v-show="images.length > 1" class="slide-button-wrap left">
                <div
                  class="slide-button prev"
                  @click="
                    activeImageIndex > 0
                      ? activeImageIndex--
                      : (activeImageIndex = images.length - 1)
                  "
                >
                  <span />
                  <span />
                </div>
              </div>
              <div v-show="images.length > 1" class="slide-button-wrap right">
                <div
                  class="slide-button next"
                  @click="
                    activeImageIndex < images.length - 1
                      ? activeImageIndex++
                      : (activeImageIndex = 0)
                  "
                >
                  <span />
                  <span />
                </div>
              </div>
            </div>
            <input
              @input="changed = true"
              ref="imageInput"
              type="file"
              accept="image/*"
              multiple
              @change="addImage"
              hidden
            />
          </div>
        </div>

        <div class="col-70">
          <div class="description-container">
            <div class="info-container mb-1">
              <div class="vhp-input dense mr-1">
                <div class="vhp-text small bold ma-1">아이디</div>
                <input
                  class="transparent outline"
                  type="text"
                  v-model="product.id"
                  readonly
                />
              </div>

              <div class="vhp-input dense">
                <div class="vhp-text small bold ma-1">브랜드</div>
                <input
                  @input="changed = true"
                  class="transparent outline"
                  type="text"
                  v-model="product.brand"
                  required
                />
              </div>
            </div>

            <div class="info-container mb-1">
              <div class="vhp-input dense">
                <div class="vhp-text small bold ma-1">카테고리</div>
                <vhp-select
                  v-model="product.category"
                  :items="category"
                  item-key="name"
                  item-value="id"
                  outline
                  dense
                />
              </div>
            </div>

            <div class="info-container mb-1">
              <div class="vhp-input dense">
                <div class="vhp-text small bold ma-1">상품이름</div>
                <input
                  @input="changed = true"
                  class="transparent outline"
                  type="text"
                  v-model="product.title"
                  required
                />
              </div>
            </div>

            <div class="info-container mb-1">
              <div class="vhp-input dense">
                <div class="vhp-text small bold ma-1">상품요약</div>
                <input
                  @input="changed = true"
                  class="transparent outline"
                  type="text"
                  v-model="product.subtitle"
                  required
                />
              </div>
            </div>

            <div class="info-container mb-1">
              <div class="vhp-input dense mr-1">
                <div class="vhp-text small bold ma-1">상품가격</div>
                <input
                  @input="changed = true"
                  class="transparent outline"
                  type="text"
                  v-model="product.price"
                  required
                />
              </div>

              <div class="vhp-input dense">
                <div class="vhp-text small bold ma-1">재고수량</div>
                <input
                  @input="changed = true"
                  class="transparent outline"
                  type="text"
                  v-model="product.quantity"
                  required
                />
              </div>
            </div>

            <div
              v-if="!product.options || product.options.length === 0"
              class="info-container column"
            >
              <div class="vhp-text small bold ma-1">상품옵션</div>
            </div>

            <template
              v-for="(option, optionIdx) in product.options"
              :key="optionIdx"
            >
              <div class="info-container column">
                <div class="vhp-text small bold mt-1 mx-1">
                  {{ "상품옵션-" + (optionIdx + 1) }}
                </div>
              </div>
              <div class="option-container my-1">
                <div class="option-container-wrap">
                  <button
                    class="close-button"
                    @click="deleteOptionItem(option)"
                  >
                    <div class="vhp-text large light">×</div>
                  </button>
                  <div class="info-container column">
                    <div class="vhp-input dense">
                      <div class="vhp-text small light mx-1">옵션명</div>
                      <input
                        @input="changed = true"
                        v-model="option.name"
                        class="transparent outline"
                        type="text"
                        required
                      />
                    </div>
                  </div>
                  <div
                    class="info-container"
                    v-for="(select, selectIdx) in option.value"
                    :key="selectIdx"
                  >
                    <div class="vhp-input dense mr-1">
                      <div class="vhp-text small light mt-1 mx-1">옵션값</div>
                      <input
                        @input="changed = true"
                        class="transparent outline"
                        type="text"
                        v-model="select.name"
                        required
                      />
                    </div>

                    <div class="vhp-input dense mr-1">
                      <div class="vhp-text small light mt-1 mx-1">옵션가</div>
                      <input
                        @input="changed = true"
                        class="transparent outline"
                        type="text"
                        v-model="select.value"
                        required
                      />
                    </div>

                    <div class="vhp-input dense">
                      <div class="vhp-text small light mt-1 mx-1">재고수량</div>
                      <input
                        @input="changed = true"
                        class="transparent outline"
                        type="text"
                        v-model="select.quantity"
                        required
                      />
                    </div>

                    <button
                      v-if="selectIdx === option.value.length - 1"
                      class="vhp-button add-button"
                      @click="option.value.push({ ...newSelect })"
                    >
                      <div class="vhp-text small light">추가</div>
                    </button>
                    <button
                      v-else
                      class="vhp-button add-button"
                      @click="deleteSelectItem(option, select)"
                    >
                      <div class="vhp-text small light red">삭제</div>
                    </button>
                  </div>
                </div>
              </div>
            </template>

            <button
              class="vhp-button mt-2 mb-0"
              @click="product.options.push({ ...newOption })"
            >
              <div class="vhp-text small">옵션추가</div>
            </button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-100 vh-80">
          <vue-editor
            v-model="product.content"
            class="ql-editor"
            @focus="changed = true"
            @text-change="editorInputChange"
          />
          <div class="img-resize-box">
            <label>
              W
              <input
                v-model="imgResizeVal"
                maxlength="4"
                @input="changed = true"
                @keydown.enter="resizeInputChange"
            /></label>
          </div>
        </div>
      </div>
    </div>

    <!-- 미리보기 모드 -->
    <div v-else class="mt-16">
      <product-layout :product="product" />
    </div>
  </div>
</template>

<script>
import ProductLayout from "@/components/layouts/ProductLayout.vue";
export default {
  name: "AdminProductDetails",
  components: { ProductLayout },
  data() {
    return {
      pageType: "",
      isPreview: false,
      changed: false,

      images: [],
      activeImageIndex: 0,

      newOption: { name: "", value: [{ name: "", value: 0, quantity: 0 }] },
      newSelect: { name: "", value: 0, quantity: 0 },

      product: {
        id: "",
        category: "",
        title: null,
        subtitle: null,
        brand: "VAZIL",
        price: 0,
        quantity: 0,
        options: [],
        images: [],
        hashTags: [],
        content: "",
        hidden: false,
      },

      category: [],

      resizeTargetImg: null,
      resizeBox: null,
      imgResizeVal: "",
    };
  },

  computed: {},
  mounted() {
    if (!this.$store.state.isAdmin) {
      alert("관리자 권한 없음");
      this.$router.push({ path: "/" });
    }
    this.init();
  },
  watch: {
    activeImageIndex() {
      if (this.activeImageIndex < 0) {
        this.activeImageIndex = 0;
      } else if (this.activeImageIndex > this.images.length - 1) {
        this.activeImageIndex = this.images.length - 1;
      }
    },
    images: {
      handler(newImages) {
        this.product.images = [...newImages];
      },
      deep: true,
    },
    // product: {
    //   handler(newProduct) {
    //     this.images = newProduct.images;
    //   },
    //   deep: true,
    // },
  },
  methods: {
    init() {
      if (this.$route.query) {
        this.pageType = this.$route.query.type;
        if (this.$route.query.id) {
          this.product.id = this.$route.query.id;
          this.getProduct(this.$route.query.id);
        } else {
          this.product.id = "@product-" + new Date().getTime();
        }
      }
      this.getCategory();
      this.resizeBox = document.querySelector(".img-resize-box");
      this.setClickOutsideEvent();
      this.setEditorScrollEvent();
    },

    async getCategory() {
      this.$axios
        .get("/category")
        .then((res) => {
          this.category = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getProduct(id) {
      if (!id) return;

      this.$axios
        .get("/product/details", { params: { id } })
        .then((res) => {
          this.product = res.data;
          this.images = [...res.data.images];
        })
        .catch((err) => {
          console.log(err);
        });
    },

    goProductPage() {
      this.$router.push({ path: "/admin/product" });
    },

    tokenAlert() {
      window.alert(
        "토큰이 만료되었습니다. 관리자 모드 해제 후 다시 로그인 해주세요."
      );
    },

    addImage(event) {
      const files = event.target.files;
      if (files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.images.push(e.target.result);
            this.activeImageIndex = this.images.length - 1;
          };
          reader.readAsDataURL(files[i]);

          // const blob = window.URL.createObjectURL(files[i]);
          // this.images.push(blob);
        }
      }
    },

    removeImage(index) {
      if (index !== -1) {
        this.images.splice(index, 1);
        this.activeImageIndex = index - 1;
      }
    },

    deleteOptionItem(item) {
      const index = this.product.options.indexOf(item);
      if (index !== -1) {
        this.product.options.splice(index, 1);
      }
    },

    deleteSelectItem(option, select) {
      const optionIndex = this.product.options.indexOf(option);

      if (optionIndex !== -1) {
        const selectIndex = option.value.indexOf(select);

        if (selectIndex !== -1) {
          this.product.options[optionIndex].value.splice(selectIndex, 1);
        }
      }
    },

    clickPrevBtn() {
      if (this.changed) {
        window.confirm(
          `페이지 이동 시 ${
            this.pageType === "create" ? "작성 내용이" : "수정 사항이"
          } 저장되지 않습니다. 이동하시겠습니까?`
        ) && this.$router.go(-1);
      } else {
        this.$router.go(-1);
      }
    },

    clickDelBtn() {
      const res = window.confirm("콘텐츠를 삭제하시겠습니까?");
      if (res) this.deleteProduct();
    },

    deleteProduct() {
      this.$axios
        .delete("/product", {
          params: {
            productId: this.product.id,
          },
        })
        .then(() => {
          this.goProductPage();
        })
        .catch((err) => {
          console.log(err);
          alert("오류가 발생하였습니다. 다시 시도해주세요.");
        });
    },

    clickSaveBtn() {
      if (this.checkValid() !== true) return;
      const res = window.confirm("저장하시겠습니까?");
      res &&
        (this.pageType === "create"
          ? this.createProduct()
          : this.editProduct());
    },

    checkValid() {
      if (!this.product.title) {
        window.alert("상품명을 입력하세요.");
      } else if (!this.product.content) {
        window.alert("내용을 입력하세요.");
      } else {
        return true;
      }
    },

    async createProduct() {
      await this.$axios
        .post("/product", {
          ...this.product,
          editor: this.$store.state.admin.username,
        })
        .then(() => {
          this.goProductPage();
        })
        .catch((err) => {
          console.log(err);
          alert("오류가 발생하였습니다. 다시 시도해주세요.");
        });
    },

    async editProduct() {
      await this.$axios
        .put("/product", {
          ...this.product,
          editor: this.$store.state.admin.username,
        })
        .then(() => {
          this.goProductPage();
        })
        .catch((err) => {
          console.log(err);
          alert("오류가 발생하였습니다. 다시 시도해주세요.");
        });
    },

    resizeInputChange() {
      this.resizeTargetImg.style.width = this.imgResizeVal + "px";

      const src = this.resizeTargetImg.src;
      const rawContent = this.content.content;
      const imgIndex = rawContent.lastIndexOf("<img", rawContent.indexOf(src));
      const imgString = rawContent.slice(
        imgIndex,
        rawContent.indexOf(">", imgIndex) + 1
      );

      if (imgString.includes("width")) {
        const widthIndex = rawContent.indexOf("width", imgIndex);
        const widthStr = rawContent.slice(
          widthIndex,
          rawContent.indexOf("px", widthIndex) + 3
        );

        this.content.content = rawContent.replace(
          imgString,
          imgString.replace(widthStr, `width="${this.imgResizeVal}px"`)
        );
      } else {
        const newImgString =
          `<img width="${this.imgResizeVal}px" ` + imgString.slice(5);
        this.content.content = rawContent.replace(imgString, newImgString);
      }

      this.$nextTick(() => {
        this.setImageClickEvent();
      });
    },

    setImageClickEvent() {
      document
        .querySelector(".ql-editor")
        .getElementsByTagName("img")
        .forEach((img) => {
          img.addEventListener("click", (e) => {
            this.resizeBox = document.querySelector(".img-resize-box");
            this.resizeTargetImg = e.target;
            this.imgResizeVal = e.target.clientWidth;
            this.resizeBox.style.display = "inline";
            this.resizeBox.style.top = e.y + "px";
            this.resizeBox.style.left = e.x + "px";
          });
        });
    },

    setEditorScrollEvent() {
      document.querySelector(".ql-container").addEventListener("scroll", () => {
        this.resizeBox.style.display = "none";
      });
    },

    setClickOutsideEvent() {
      window.addEventListener("click", this.clickOutsideEvent);
    },

    editorInputChange(delta) {
      const isImageExist = delta.ops.some((o) => o.insert?.image);
      isImageExist && this.setImageClickEvent();
    },
  },
};
</script>

<style lang="scss" src="./details.scss"></style>
